import React, { useContext, useState, useEffect } from 'react';
import { Entity, Page, Table } from '../../components';

import { Modal, Tabs, message, Button, Divider, Form, Checkbox, Space, Row } from 'antd';

import { getListEnabled as getSupplierList } from '../../services/Supplier';
import { getListEnabled, deleteById } from '../../services/Entity';
import {
  getList as getAuthorities,
  deleteUser,
  updateUser,
  insertUser
} from '../../services/Authority';
import {
  EditOutlined,
  DeleteOutlined,
  SaveOutlined,
  ExclamationCircleOutlined
} from '@ant-design/icons';
import { MasterContext } from '../../App';
import { default as UserNew } from './UserNew';
import './style';

export default React.forwardRef((props, ref) => {
  const { port, container, country, user_category, reload } = useContext(MasterContext);
  const [suppliers, setSuppliers] = useState([]);
  const [warehouses, setWarehouses] = useState([]);
  const [users, setUsers] = useState([]);
  const [isShowPermission, setShowPermission] = useState(false);
  const [selectedUser, setSelectedUser] = useState({});
  const [userPermissonCategory, setUserPermissionCategory] = useState([]);
  const [userPermission, setUserPermission] = useState([]);
  const [isShowUserNew, setShowUserNew] = useState(false);
  const [isShowUserEdit, setShowUserEdit] = useState(false);
  const showDeleteConfirm = (id, name) => {
    Modal.confirm({
      title: '确定删除当前项目吗?',
      icon: <ExclamationCircleOutlined />,
      content: <strong>{id + ' : ' + name}</strong>,
      okText: 'Yes',
      centered: true,
      okType: 'danger',
      cancelText: 'No',
      onOk() {
        deleteUser(id).then(() => {
          reloadUser();
        })
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  const onEditUser = (index) => {
    setSelectedUser(users[index]);
    setShowUserEdit(true);
  }
  const onDeleteUser = (index) => {
    setSelectedUser(users[index]);
    showDeleteConfirm(users[index].id, users[index].name);
  }
  const [form] = Form.useForm();
  const { TabPane } = Tabs;
  const onClickPermission = (user) => {
    getAuthorities(user.id).then((data) => {
      user.authorities = data || [];
      setSelectedUser(user);
      setShowPermission(true);
    });
  }

  const reloadUser = () => {
    getListEnabled('fm_user').then(data => setUsers(data));
  }

  useEffect(() => {
    getSupplierList().then(data => {
      const temp = [{ id: 0, name: '-' }].concat((data || []));
      setSuppliers(temp);
    });
    getListEnabled('fm_warehouse').then(data => setWarehouses(data));
    getListEnabled('fm_user_role_permission_category').then(data => {
      setUserPermissionCategory(data);
    });

    reloadUser();

    getListEnabled('fm_user_role_permission').then(data => {
      setUserPermission(data);
    });
  }, []);

  function callback(key) {
    console.log(key);
  }
  const formItemLayout = {
    labelCol: { width: '20rem' },
    wrapperCol: { span: 20 },
  };

  const onNewUserCallback = async (values, callback) => {
    const key = 'create_user';
    console.log('onNewUserCallback:', values);
    message.loading({ content: '正在新用户...', key });
    insertUser(values).then(() => {
      message.success({ content: `新用户创建成功`, key, duration: 2 });
      reloadUser();
      reload('user');
      callback && callback();
    });
  }

  const onEditUserCallback = async (values, callback) => {
    const key = 'edit_user';
    console.log('onEditUserCallback:', values);
    message.loading({ content: '正在修改用户...', key });
    updateUser(selectedUser.id, values).then(() => {
      message.success({ content: `用户修改成功`, key, duration: 2 });
      reloadUser();
      reload('user');
      callback && callback();
    });
  }

  return (
    <div style={{ padding: '0.5rem 1.5rem', height: '100%' }}  >
      <div className="card-container" style={{ height: '100%' }}>
        <Tabs type="card" style={{ height: 'calc(100% - 1rem)' }}>
          <TabPane tab="报关品名" key="1">
            <Entity reload={reload} entity="fm_goods_category" />
          </TabPane>
          <TabPane tab="国家" key="2">
            <Entity reload={reload} entity="fm_country" />
          </TabPane>
          <TabPane tab="港口" key="3">
            <Entity reload={reload} entity="fm_port" relation={{ country_id: { data: country, field: 'name_cn' } }} />
          </TabPane>
          <TabPane tab="集装箱" key="4">
            <Entity reload={reload} entity="fm_container" />
          </TabPane>
          <TabPane tab="港口-集装箱" key="5">
            <Entity entity="fm_port_container" relation={
              {
                container_id: { data: container, field: 'name' },
                port_id: { data: port, field: 'name_cn' }
              }
            } />
          </TabPane>
          <TabPane tab="运输条款" key="6">
            <Entity reload={reload} entity="fm_transport" />
          </TabPane>
          <TabPane tab="支付方式" key="7">
            <Entity reload={reload} entity="fm_payment" />
          </TabPane>
          <TabPane tab="货币种类" key="8">
            <Entity reload={reload} entity="fm_currency" />
          </TabPane>
          <TabPane tab="仓库" key="9">
            <Entity reload={reload} entity="fm_warehouse" />
          </TabPane>

          <TabPane tab="唛头格式" key="10">
            <Entity reload={reload} entity="fm_shipmark" />
          </TabPane>
          <TabPane tab="用户列表" key="11">
            <Table
              title="用户管理"
              newLabel={"新建用户"}
              showNewLabel="true"
              rows={users}
              total_rows={users.length}
              onNew={() => setShowUserNew(true)}
              header={[
                {
                  label: '登录帐号', width: '220px', align: 'center', item: 'account', render: (text, row, index) => {
                    return <span>{text}</span>
                  }
                },
                {
                  label: '用户名称', width: '220px', align: 'center', item: 'name', render: (text, row, index) => {
                    return <span>{text} {row.company_id > 0 && '(' + (((row.category_id === 3 ? suppliers : warehouses) || []).find(x => x.id === row.company_id) || {}).name + ')'}</span>
                  }
                },
                {
                  label: '用户类型', width: '90px', align: 'center', item: 'category_id', render: (text, row, index) => {
                    return <span>{user_category.find(x => x.id === text).name}</span>
                  }
                },
                {
                  label: '邮箱', width: '160px', align: 'center', item: 'email'
                },
                {
                  label: '电话', width: '115px', align: 'center', item: 'tel'
                },
                {
                  label: '显示顺序', width: '60px', align: 'center', item: 'display_order'
                },
                {
                  label: '是否启用', width: '60px', align: 'center', item: 'enabled', render: (text, row, index) => {
                    return <Checkbox checked={text} />
                  }
                },
                {
                  label: '是否允许登录系统', width: '100px', align: 'center', item: 'login_able', render: (text, row, index) => {
                    return <Checkbox checked={text} />
                  }
                },
                {
                  label: '操作', width: '120px', align: 'center', item: 'login_able', render: (text, row, index) => {
                    return <Space size="small">
                      <Button size="small" onClick={() => onEditUser(index)} icon={<EditOutlined />} />
                      <Button danger size="small" onClick={() => onDeleteUser(index)} icon={<DeleteOutlined />} />
                    </Space>
                  }
                },
              ]}
            />
          </TabPane>
          <TabPane tab="公司" key="12">
            <Entity reload={reload} entity="fm_company" />
          </TabPane>
        </Tabs>
      </div>
      <Page
        isMaximize={true}
        body={<UserNew onCloseCallback={() => setShowUserNew(false)} onSaveCallback={onNewUserCallback} />}
        onCloseCallback={() => setShowUserNew(false)}
        visible={isShowUserNew} title={"新建用户"}
      />
      <Page
        isMaximize={true}
        body={<UserNew user={selectedUser} onCloseCallback={() => setShowUserEdit(false)} onSaveCallback={onEditUserCallback} />}
        onCloseCallback={() => setShowUserEdit(false)}
        visible={isShowUserEdit} title={"编辑用户"} />
    </div>
  );
});
